import { Space } from "antd";
import { FullSubStatusName } from "../fullSubStatusName/fullSubStatusName";
import { IncomingTransitionIcon } from "../../incomingTransitionIcon/incomingTransitionIcon";
import styles from "./incomingTransitionItem.module.scss";

export const IncomingTransitionItem = ({
  isActive,
  statusName,
  subStatusName,
}) => {
  return (
    <div
      className={`${styles.incomingTransitionItem} ${
        !isActive ? styles.disabled : ""
      }`}
    >
      <Space size="small">
        <IncomingTransitionIcon />

        <FullSubStatusName statusName={statusName}>
          {subStatusName}
        </FullSubStatusName>
      </Space>
    </div>
  );
};
